import script from "./Accident.vue?vue&type=script&setup=true&lang=js"
export * from "./Accident.vue?vue&type=script&setup=true&lang=js"

import "./Accident.vue?vue&type=style&index=0&id=46537614&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46537614"]])

export default __exports__